import { render, staticRenderFns } from "./addBaseAdData.vue?vue&type=template&id=2e962a0a&scoped=true"
import script from "./addBaseAdData.vue?vue&type=script&lang=js"
export * from "./addBaseAdData.vue?vue&type=script&lang=js"
import style0 from "./addBaseAdData.vue?vue&type=style&index=0&id=2e962a0a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e962a0a",
  null
  
)

export default component.exports